import React, { Fragment, useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function Newsletter() {
  const {
    strings,
    order,
    setOrder
  } = useContext(CarOrderingContext)

  const onChange = function (e) {
    const newOrder = { ...order }
    newOrder.newsletter = e.target.checked ? 'yes' : 'no'

    setOrder(newOrder)
  }

  if (typeof strings.checkout.newsletter.label !== 'string' || strings.checkout.newsletter.label.length === 0) {
    return null
  }

  return (
    <>
      <h2 className='config-form__subtitle newsletter'>
        {strings.checkout.newsletter.label}
        <div className='config-tooltip'/>
      </h2>

      <div className='config-checkbox newsletter'>
        <label htmlFor='newsletter'>
          <input type='checkbox' name='consent' id='newsletter' onChange={onChange}/>
          <div dangerouslySetInnerHTML={{ __html: strings.checkout.newsletter.description }}/>
        </label>
      </div>
    </>
  )
}
